import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { useToast } from "../../components/ui/use-toast";
import { X, Loader2 } from "lucide-react";
import { Trans, t } from '@lingui/macro';
import { useState, useEffect } from "react";
import { useHistory } from "../../hooks/useRouterCompat";
import { Room } from "../../models/Room";
import { UUID } from "../../models/local/Uid";
import { Fire } from "../../services/FireClient";
import { My } from "../../services/My";
import RoomForm from "./RoomFormPart";

export const CreateRoomModal: React.FC<{ show: boolean, setShow: (v: boolean) => void, workspaceId: string | null }> = ({ show, setShow, workspaceId }) => {
  const [room, setRoom] = useState<Room>();
  const { toast } = useToast();
  const history = useHistory();
  const [inProgress, setInProgress] = useState(false);
  const [uploadedImage, setUploadedImage] = useState<File | null>(null);

  useEffect(() => {
    if (show) {
      onPresent();
    }
  }, [show]);

  function onPresent() {
    let r = new Room("", My.user.id);
    r.workspaceId = workspaceId;
    setRoom(r);
  }

  async function saveRoom() {
    if (!room?.name) {
      toast({ title: t`Room name is required`, duration: 1000 });
      return;
    } else if (!room?.workspaceId) {
      toast({ title: t`Workspace is required`, duration: 1000 });
      return;
    }
    room.users = [My.user];
    room.userIds = [My.user.id]
    setInProgress(true);
    if (uploadedImage) {
      Fire.uploadFile(uploadedImage, `/rooms/${room.id}/cover/${UUID.get()}.jpg`, url => {
        room.profileImageUrl = url;
        saveRoom2(room);
      }, null);
    } else {
      saveRoom2(room);
    }
  }

  async function saveRoom2(r: Room) {
    await Fire.saveRoom(r);
    setInProgress(false);
    setShow(false);
    history.push(`/room/${r.id}`);
    toast({ title: t`Room saved`, duration: 1000 });
  }

  return (
    <Dialog open={show} onOpenChange={setShow}>
      <DialogContent className="sm:max-w-2xl max-h-[90vh] flex flex-col p-6 gap-6 overflow-hidden [&>button]:hidden">
        <DialogHeader className="flex flex-row items-center justify-between space-y-0 p-0">
          <Button variant="ghost" size="icon" onClick={() => setShow(false)} className="-ml-2">
            <X className="w-6 h-6" />
          </Button>
          <DialogTitle className="text-xl font-semibold"><Trans>Create room</Trans></DialogTitle>
          <Button onClick={saveRoom} disabled={inProgress} className="bg-orange-500 hover:bg-orange-600">
            {inProgress && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
            <Trans>Save</Trans>
          </Button>
        </DialogHeader>

        <div className="flex-1 overflow-y-auto -mx-2 px-2">
          {room && <RoomForm room={room} onUploadImageSelected={setUploadedImage} />}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default CreateRoomModal;